export default "__VITE_ASSET__VofGMEjr__"